/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core';
import LanguageMenu from './LanguageMenu';
import UserMenu from './UserMenu';
import NotificationMenu from './NotificationMenu';

const useStyles = makeStyles(theme => ({
  languageMenu: {
    marginRight: '1rem',
    [theme.breakpoints.down('sm')]: {
      marginRight: '0.5rem',
    },
  },
  profileMenu: {
    [theme.breakpoints.down('md')]: {
      marginLeft: '2.5rem',
    },
  },
}));

export default function TopNavigation({ user, currentOrganization }) {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <>
      <NotificationMenu userId={user?.id} notifications={user?.pendingInvitations} />
      <LanguageMenu className={classes.languageMenu} />
      <UserMenu className={classes.profileMenu} user={user} currentOrganization={currentOrganization} />
    </>
  );
}
